<div 
#pin
class="label-pin"
[ngClass]="{
  'label-pin--light': labelTheme === labelThemeEnum.StudioNext,
  'label-pin--dark': labelTheme === labelThemeEnum.Annotation,
  'label-pin--none': label.pinType === labelPinType.None,
  'label-pin--selected': selected
}">

<!-- Pins: Dark Theme -->
<ng-container *ngIf="labelTheme === labelThemeEnum.Annotation;else lightPins">
  <img draggable="false" *ngIf="label.pinType == labelPinType.Default" alt="" src="./assets/images/labels/circle-dark.svg" class="label-pin__image">
  <img draggable="false" *ngIf="label.pinType == labelPinType.Sequential" alt="" src="./assets/images/labels/circle-dark.svg" class="label-pin__image">
  <img draggable="false" *ngIf="label.pinType === labelPinType.Plus || (label.pinType === labelPinType.PlusMinus && !selected)" alt="" src="./assets/images/labels/circle-plus-dark.svg" class="label-pin__image">
  <img draggable="false" *ngIf="label.pinType === labelPinType.Minus || (label.pinType === labelPinType.PlusMinus && selected)" alt="" src="./assets/images/labels/circle-minus-dark.svg" class="label-pin__image">
</ng-container>

<!-- Pins: Light Theme -->
<ng-template #lightPins>
  <img draggable="false" *ngIf="label.pinType == labelPinType.Default" alt="" src="./assets/images/labels/circle.svg" class="label-pin__image">
  <img draggable="false" *ngIf="label.pinType == labelPinType.Sequential" alt="" src="./assets/images/labels/circle.svg" class="label-pin__image">
  <img draggable="false" *ngIf="label.pinType === labelPinType.Plus || (label.pinType === labelPinType.PlusMinus && !selected)" alt="" src="./assets/images/labels/circle-plus.svg" class="label-pin__image">
  <img draggable="false" *ngIf="label.pinType === labelPinType.Minus || (label.pinType === labelPinType.PlusMinus && selected)" alt="" src="./assets/images/labels/circle-minus.svg" class="label-pin__image">
</ng-template>

<!-- Sequence -->
<ng-container *ngIf="label.pinType === labelPinType.Sequential">
  <div 
    class="label-pin__text"
    [ngClass]="{
      'label-pin__text--white': labelTheme === labelThemeEnum.StudioNext,
      'label-pin__text--black': labelTheme === labelThemeEnum.Annotation
    }">
    {{ sequence }}
  </div>
</ng-container>

<!-- Glow -->
<div class="label__glow"></div>
</div>